<div id="home-creative" class="container px-4">
  <div class="row">
    <div class="col-12 col-lg-5 ps-3 ps-lg-4 border-linea border-radius-2 border-secondary-creative-500">
      <p class="primary-800 tabs">SEGO <span class="secondary-creative-500">Creative</span></p>
      <h1 class="primary-900">Invierte en <br>cultura</h1>
    </div>
    <div class="col-12 col-lg-7 gx-0 d-flex flex-column justify-content-end">
      <p class="p2-medium neutral-500 my-2">
        Invierte con SEGO Creative en los <strong class="p2-bold">mejores proyectos audiovisuales.
        </strong>Participa en su crecimiento hasta <strong class="p2-bold">alcanzar el éxito.</strong>
      </p>
    </div>
    <div class="col-12 mt-3 mb-2 bg-primary-100 border-radius-4 p-2">
      <div class="mx-3 mx-lg-4">
        <p class="p3-regular neutral-900">
          Producto ofrecido por SociosInversores 2010 SL, Proveedor de Servicios de Financiación
          Participativa, supervisado por CNMV y registrado en la Autoridad Europea de Supervisión de Valores y Mercados (AEVM) con Licencia nº 7. Sujeto al Reglamento (UE) 2020/1503 del Parlamento Europeo.
        </p>
      </div>

    </div>
  </div>

  @if (isLoading) {
    <div class="mt-5 p-5">
      <app-is-loading [color]="'creative'"></app-is-loading>
    </div>
  }

  @if (!isLoading && oportunidadCreative) {
    <div class="row mt-3 mt-lg-4 fadein ">
      <div class="col-12 gx-0 mx-auto">
        <app-ficha-op-abierta-audiovisual [ref]="'home'" [totalOportunidades]="1"
        [oportunidad]="oportunidadCreative"></app-ficha-op-abierta-audiovisual>
      </div>
    </div>
  }

  @if (!isLoading && !oportunidadCreative) {
    <div class="row mt-3 mt-lg-4 fadein">
      <div class="col-12 gx-0 mt-4">
        <app-subiendo-oportunidades [line]="'creative'"></app-subiendo-oportunidades>
      </div>
    </div>
  }

  <div class="row mt-4">
    <div class="col-12 col-lg-5 col-xl-4 gx-0 gx-lg-4 mx-auto text-center">
      @if (platformId === 'CREATIVE') {
        <a id="home-oportunidades-creative" class="btn btn-primary w-100"
          title="Ver todas las oportunidades" routerLink="/audiovisuales">
          <div class="d-flex align-items-center justify-content-center">
            <span>Ver oportunidades audiovisuales</span> <span
          class="material-symbols-outlined ms-2">chevron_right</span>
        </div>
      </a>
    }
    @if (platformId !== 'CREATIVE') {
      <a id="home-oportunidades-creative" class="btn btn-primary w-100"
        title="Ver todas las oportunidades" href="{{domainUrl + '/audiovisuales'}}"
        target="{{platformId === 'REALESTATE' || platformId === 'VENTURE' ? '_self' : '_blank'}}">
        <div class="d-flex align-items-center justify-content-center">
          <span>Ver oportunidades audiovisuales</span> <span
        class="material-symbols-outlined ms-2">chevron_right</span>
      </div>
    </a>
  }
</div>
</div>
</div>